import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { parseInt } from 'lodash';

import { logoContentPropTypes } from '../../../config/sectionHeader/sectionHeaderPropTypes';
import headerContentAlignment from '../../../config/sectionHeader/headerContentAlignment';
import HeaderLogoEditor from '../HeaderLogoEditor';
import HeaderLogo from '../HeaderLogo';
import HeaderLogoPlaceholderContainer from '../HeaderLogoPlaceholderContainer';

import styles, { headerLogoHorizontalPadding } from './HeaderLogoContent.scss';

class HeaderLogoContent extends Component {
  static propTypes = {
    isEditMode: PropTypes.bool,
    ...logoContentPropTypes,
  };

  static defaultProps = {
    isEditMode: false,
    logoImageAlign: headerContentAlignment.left,
    logoImageUrl: '',
  };
  static headerLogoHorizontalPadding =
    parseInt(headerLogoHorizontalPadding) * 2;

  render() {
    const {
      isEditMode,
      logoImageUrl,
      logoImageAlign,
      logoImageLinkUrl,
      containerSize: { width, height },
      logoImageSize,
      logoImageSizePreset,
    } = this.props;

    const shouldRenderLogoPlaceholder = isEditMode && !logoImageUrl;
    if (shouldRenderLogoPlaceholder)
      return (
        <HeaderLogoPlaceholderContainer
          align={logoImageAlign}
          containerHeight={height}
        />
      );

    const restrictedHeaderSize = {
      width: width - HeaderLogoContent.headerLogoHorizontalPadding,
      height,
    };
    const HeaderLogoComponent = isEditMode ? HeaderLogoEditor : HeaderLogo;

    return (
      <HeaderLogoComponent
        headerSize={restrictedHeaderSize}
        logoImageUrl={logoImageUrl}
        logoImageLinkUrl={logoImageLinkUrl}
        logoImageAlign={logoImageAlign}
        sizePreset={logoImageSizePreset}
        size={logoImageSize}
        className={styles.container}
      />
    );
  }
}

export default HeaderLogoContent;
